<div class="forgotPassword-container">
  <app-mobile-header [title]="'button.forgot.password'"></app-mobile-header>
  <div class="forgotPassword-content">
    <img src="assets/generalImage/password_lock.svg" loading="lazy" alt="image" />
    <app-reset-pass-form [pageName]="pageName" (onSubmitted)="onFormSubmit($event)"></app-reset-pass-form>
  </div>
</div>
